import { jsx as _jsx } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
export function LinkComponent({ to, ...restProps }) {
    if (restProps.disabled) {
        // eslint-disable-next-line jsx-a11y/anchor-is-valid, jsx-a11y/anchor-has-content, no-script-url
        return _jsx("a", { href: 'javascript:void(0)', ...restProps });
    }
    return _jsx(Link, { to: to, ...restProps });
}
